module.exports = __webpack_public_path__ + "static/media/locationbanner.b080c0ac.png";